import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  ThinDropdown,
  ThinTextField,
  AddButton,
  ThinDropdownWithSearch,
  BackButton,
} from "../../common/GeneralComponent";
import { fetchData } from "../../../utils/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "../../../components/partials/Loader";

const AddTehsile = () => {
  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch districts on mount
  React.useEffect(() => {
    const fetchDistricts = async () => {
      setLoader(true);
      try {
        const response = await fetchData(
          "districts",
          "GET",
          null,
          {},
          {},
          navigate,
          "/districts",
          dispatch
        );
        setFilteredDistricts(response?.data || []);
      } catch (error) {
        toast.error("Failed to load districts");
      } finally {
        setLoader(false);
      }
    };
    fetchDistricts();
  }, [navigate, dispatch]);

  const validationSchema = Yup.object({
    Tehsil_Name: Yup.string()
      .max(50, "Tehsil Name cannot exceed 50 characters")
      .required("Tehsil Name is required"),
    District_Id: Yup.string().required("District is required"),
  });

  const formik = useFormik({
    initialValues: {
      Tehsil_Name: "",
      District_Id: "",
      Status: 1,
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      const data = {
        tehsil_name: values?.Tehsil_Name,
        district_id: values?.District_Id,
        status: values.Status,
      };
      try {
        const response = await fetchData(
          "tehsils",
          "POST",
          data,
          {},
          {},
          navigate,
          "/tehsils",
          dispatch
        );
        toast.success(response.message);
        formik.resetForm();
        navigate("/tehsils");
      } catch (error) {
        toast.error(error.message);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div className="w-full my-4 mx-auto">
      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Create Tehsil
        </h1>
        <BackButton text="Back" to="/tehsils" />
      </div>

      <div className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4 mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create Tehsil
          </h1>
        </div>

        <form className="p-4" onSubmit={formik.handleSubmit}>
          <div className="grid lg:grid-cols-2 gap-5 grid-cols-1">
            <ThinDropdownWithSearch
              label="District"
              id="district-dropdown"
              options={
                filteredDistricts?.map((district) => ({
                  value: district.District_Id || district.district_id,
                  label: district.District_Name || district.district_name,
                })) || []
              }
              value={formik.values.District_Id}
              onChange={(value) => formik.setFieldValue("District_Id", value)}
              error={formik.touched.District_Id && formik.errors.District_Id}
              helperText={
                formik.touched.District_Id && formik.errors.District_Id
              }
            />

            <ThinTextField
              id="Tehsil_Name"
              label="Tehsil Name"
              placeholder="Enter Tehsil Name"
              type="text"
              name="Tehsil_Name"
              value={formik.values.Tehsil_Name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.Tehsil_Name && formik.errors.Tehsil_Name}
              helperText={
                formik.touched.Tehsil_Name && formik.errors.Tehsil_Name
              }
            />

            <ThinDropdown
              label="Status"
              id="status-dropdown"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
              ]}
              value={formik.values.Status}
              onChange={(e) => formik.setFieldValue("Status", e.target.value)}
              error={formik.touched.Status && formik.errors.Status}
              helperText={formik.touched.Status && formik.errors.Status}
            />
          </div>

          <div className="p-4">
            <AddButton type="Submit" text="Submit" isLoading={isSubmitting} />
          </div>
        </form>
      </div>

      {loader && <Loader />}
    </div>
  );
};

export default AddTehsile;
